<template>
	<div
		v-b-visible="onPanelVisible"
		class="panel partners-overview theme-image"
		:style="headerStyle"
	>
		<div class="container">
			<div class="partners_overview">
				<ul v-if="block.items" class="partners_list row">
					<li v-for="(item, index) in block.items" :key="index" class="col-12 col-md-12 col-lg-6">
						<div class="partner_about_block">
							<div class="partner_about_block_top">
								<p v-if="item.title" class="title title-lg">
									{{ item.title }}
								</p>
								<div v-if="item.description" class="description" v-html="item.description" />
							</div>
							<div class="partner_about_block_bottom">
								<dynamic-button
									v-if="item.button"
									:button="item.button"
									:block-id="block.id"
									:scenario="item.button.button_scenario"
								/>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import panel from '@/mixins/panel';

export default {
	name: 'PanelSn01',
	mixins: [panel],
	props: ['block'],
	data() {
		return {
			headerStyle: null,
		};
	},
	methods: {
		onPanelVisible(visible) {
			if (visible) {
				this.headerStyle = `background-image: url(${this.block.background_image.src})`;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import "~/assets/styles/components/home/panel-partners-overview";
</style>
